<div class="{{ footer }} {{ userDeviceInfo }}">
  <div [class.new]="isNew" class="_header">
    <!-- <app-unsupported-browser *ngIf="isNotChrome" [deviceOs]="deviceOs"></app-unsupported-browser> -->
    @if (header === 'simple') {
      <div class="logo">
        <a (click)="user ? goHome() : goMain()"></a>
        <!-- <div #language class="option-select languages">
        <div class="language" (click)="language.classList.toggle('active')">
          <img src="/assets/images/{{ lang.locale }}.svg" />{{ lang.label | t }}
        </div>
        <div class="options">
          <div
            [class.selected]="lang.locale === language.locale"
            (click)="onChangeLanguage(language.locale)"
            *ngFor="let language of LANGUAGES"
            >
            <img src="/assets/images/{{ language.locale }}.svg" />{{ language.label | t }}
          </div>
        </div>
      </div> -->
      </div>
    }
    <div></div>
    @if (header === 'closed') {
      <div id="closed-search-header">
        <a (click)="goBack()" class="back-link" [innerHTML]="'TERM.BACK' | t">Back</a>
        <a (click)="goHome()" class="home-link" [innerHTML]="'TERM.HOME' | t">Home</a>
        <a (click)="searchModal.openSearchModal()" class="closed-search-link" [innerHTML]="'TERM.SEARCH' | t">Search</a>
        <a class="my" [routerLink]="['/my']" routerLinkActive="active"> MY </a>
        <app-my-cart></app-my-cart>
      </div>
    }
    @if (header === 'opened') {
      <div id="opened-search-header">
        <a (click)="goHome()" class="home-link" [innerHTML]="'TERM.HOME' | t">Home</a>
        <div class="inner-search">
          <input
            (click)="searchModal.openSearchModal()"
            type="search"
            autocomplete="off"
            [placeholder]="'SEARCH.SEARCH_TITLE' | t"
          />
        </div>
        <a class="my" [routerLink]="['/my']" routerLinkActive="active"> MY </a>
        <app-my-cart></app-my-cart>
      </div>
    }
    @if (header === 'opened' || header === 'closed') {
      <app-search-modal #searchModal></app-search-modal>
    }
    <!-- <div
  class="swiper-container notice-container"
  [class.show_search]="header !== 'closed'"
  *ngIf="noticeBoards.length !== 0"
  >
  <div class="notice-button-box" [class.show_search]="header !== 'closed'">
    <img
      src="/assets/images/chevron-back-outline.svg"
      class="button-prev-notice"
      [class.isDisable]="isDisablePrev"
      alt=""
      (click)="$event.stopPropagation()"
      />
    <img
      src="/assets/images/chevron-forward-outline.svg"
      class="button-next-notice"
      [class.isDisable]="isDisableNext"
      alt=""
      (click)="$event.stopPropagation()"
      />
  </div>
  <swiper
    [class.show_search]="header !== 'closed'"
    fxFlex="auto"
    (indexChange)="onChangeNoticeBanner($event)"
    [config]="visualNoticeConfig"
    >
    <div class="section-notice swiper-slide" *ngFor="let noticeBoard of noticeBoards; let i = index">
      <img src="/assets/images/icon-noti.svg" />
      <a class="inner" (click)="goPage('/my/notice/' + noticeBoard.id, i)">{{ noticeBoard.subject }}</a>
    </div>
  </swiper>
</div> -->
  </div>

  <router-outlet></router-outlet>
  <app-select-bulk-product></app-select-bulk-product>
  <app-select-product></app-select-product>

  <!-- 앱이 있다면...해당 버튼 비노출해야됨.. -->
  @if (userDeviceInfo === 'mobile') {
    <div id="appDownloadButton_wrapper" #target>
      <div id="appDownloadbutton_box">
        <a id="appDownloadButton" role="button" (click)="downloadApp()">Download APP</a>
        <a id="appDownloadButton_close" role="button" (click)="downloadDelay($event)">Close</a>
      </div>
    </div>
  }
  <app-go-to-top></app-go-to-top>
  <!-- <app-add-to-cart></app-add-to-cart> -->
  @if (footer === 'common') {
    <footer class="common">
      <ul class="links">
        <li>
          <a (click)="goMainUrl('our-story')" target="_blank" [innerHTML]="'FOOTER.ABOUT' | t">About us</a>
        </li>
        <li>
          <a [routerLink]="['/policy']" target="_blank" [innerHTML]="'FOOTER.SERVICE_TERMS' | t">Terms of service</a>
        </li>
        <li>
          <a href="/policy?type=PRIVACY" target="_blank" [innerHTML]="'FOOTER.PRIVACY_POLICY' | t">Privacy Policy</a>
        </li>
        <li>
          <a href="/my/faq">FAQ</a>
        </li>
        <!-- <li>
      <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
      <a href="https://api.whatsapp.com/send?phone=821030570534" target="_blank">CS Manager (All Inquiries)</a>
    </li> -->
        <!-- <li>
    <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
    <a href="https://api.whatsapp.com/send?phone=821066930534" target="_blank">Asia (IN, MY, EN)</a>
  </li>
  <li>
    <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
    <a href="https://api.whatsapp.com/send?phone=821066950534" target="_blank">CIS (RU, EN)</a>
  </li> -->
        <!-- <li>
  <a href="javascript:void(0);" style="cursor: default;">10:00 ~ 19:00 KST, Mon ~ Fri</a>
</li> -->
      </ul>
      <!-- <div class="whatsapp">
<dl>
  <dt>
    <img src="https://umma.io/wp-content/themes/umma2022/images/icons/icon-whatsapp.png" alt="whatsapp" />
    <a href="https://api.whatsapp.com/send?phone=821024610534" target="_blank">
      <p style="top: 130px;">America & Europe (EN, KO)</p>
    </a>
  </dt>
  <dt>
    <a href="https://api.whatsapp.com/send?phone=821066930534" target="_blank">
      <p style="top: 165px;">Asia (IN, MY, EN)</p>
    </a>
  </dt>
  <dt>
    <a href="https://api.whatsapp.com/send?phone=821066950534" target="_blank">
      <p style="top: 195px;">CIS (RU, EN)</p>
    </a>
  </dt>
  <dd>(10:00 ~ 19:00 KST, Mon ~ Fri)</dd>
</dl>
</div> -->
      <div class="sns">
        <!-- <h2>
  <a class="underline-action white" (click)="goMainUrl('umma-beauty')">umma blog</a>
</h2> -->
        <a class="umma-blog" (click)="goMainUrl('umma-beauty')" target="_blank">UMMA blog</a>
        <a
          class="facebook"
          [href]="
            lang.locale === LANGUAGE_TYPE.EN
              ? 'https://www.facebook.com/UMMA-global-104619111257386'
              : 'https://www.facebook.com/ummavn'
          "
          target="_blank"
        ></a>
        <a
          class="insta"
          [href]="
            lang.locale === LANGUAGE_TYPE.EN
              ? 'https://www.instagram.com/umma_wholesale/'
              : 'https://www.instagram.com/umma_wholesale/'
          "
          target="_blank"
        ></a>
        <a
          class="tictok"
          [href]="
            lang.locale === LANGUAGE_TYPE.EN
              ? 'https://www.tiktok.com/@umma.wholesale'
              : 'https://www.tiktok.com/@umma.wholesale'
          "
          target="_blank"
        ></a>
      </div>
      <div class="payment">
        <h2 [innerHTML]="'FOOTER.PAYMENT' | t">Payment method</h2>
        <p>We accept following payment methods online.</p>
        <div class="lists">
          <span><img src="../../../../assets/images/icon-payment-tt.png" alt="tt" /></span>
          <span><img src="../../../../assets/images/icon-payment-visa.jpg" alt="visa" /></span>
          <span><img src="../../../../assets/images/icon-payment-master.jpg" alt="master" /></span>
          <span><img src="../../../../assets/images/icon-payment-american.jpg" alt="american" /></span>
          <span><img src="../../../../assets/images/icon-payment-paypal.jpg" alt="paypal" /></span>
          <span><img src="../../../../assets/images/icon-payment-payoneer.jpg" alt="payoneer" /></span>
        </div>
      </div>
      <div class="more">
        <h2 (click)="scrollToBottom(footerMore)" [class.active]="footerMore.classList.contains('active')">
          &copy; umma
          <i class="icon-toggle-arrow">
            <span class="icon-toggle-arrow__i"></span>
          </i>
        </h2>
        <div #footerMore>
          <ul>
            <li>CEO : Hangil Chun</li>
            <li><span [innerHTML]="'FOOTER.BUSINESS_NUMBER' | t">Business Number</span> : 261-81-14845</li>
            <li>
              <span [innerHTML]="'FOOTER.CONTACT' | t">Contact</span> :
              <a href="mailto:cs@umma.io">cs&#64;umma.io</a>
            </li>
          </ul>
          <p [innerHTML]="'FOOTER.ADDRESS' | t">
            Seoul Office : 4th Floor, 152 Teheran-ro, Gangnam-gu, Seoul, Republic of Korea (06236)
          </p>
          <p>Korea Warehouse : {{ WAREHOUSE.KR.address }}</p>
          <p>Europe Warehouse : {{ WAREHOUSE.EU.address }}</p>
          <p>America Warehouse : {{ WAREHOUSE.US.address }}</p>
        </div>
      </div>
    </footer>
  }
  @if (footer === 'single') {
    <footer class="single">
      <p [innerHTML]="'FOOTER.COPY_RIGHT_SMALL' | t">
        Copyright © UMMA and Craver Corporation. All Rights Reserved 2019
      </p>
    </footer>
  }
  @if (gnb === true) {
    <div class="gnb">
      <ul>
        <li class="home" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
          <a [routerLink]="HOME_URL" [innerHTML]="'TERM.NAVIGATION.UMMA' | t">UMMA</a>
        </li>
        <li class="category" routerLinkActive="active">
          <a [routerLink]="['/category']" [innerHTML]="'TERM.NAVIGATION.CATEGORY' | t">CATEGORY</a>
        </li>
        <li class="brand" routerLinkActive="active">
          <a [routerLink]="['/brand']" [innerHTML]="'TERM.NAVIGATION.BRAND' | t">BRAND</a>
        </li>
        <li class="u-quick" routerLinkActive="active">
          <a [routerLink]="['/u-quick']">
            <span class="link__tab-text">U-Quick</span>
          </a>
        </li>
        @if (uDirectService.isUDirect) {
          <li class="u-direct" routerLinkActive="active">
            <a [routerLink]="uDirectService.getUDirectPath()">
              <span class="link__tab-text">U-Direct <span class="icon_new">NEW</span></span>
            </a>
          </li>
        }
        <li class="offers" routerLinkActive="active">
          <a [routerLink]="['/promotion-notice']">
            <span class="link__tab-text"
              >Offers
              @if (!uDirectService.isUDirect) {
                <span class="icon_new">NEW</span>
              }
            </span>
          </a>
        </li>
      </ul>
    </div>
  }
</div>
